import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'default-date-time',
  templateUrl: './default-date-time.component.html',
  styleUrls: ['./default-date-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe, DatePipe],
})
export class DefaultDateTimeComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject([]);
  additionData: Observable<any> = new BehaviorSubject([]);
  constructor() {}

  ngOnInit(): void {}
  dateType(day: any) {
    if (
      day &&
      (day.toLowerCase() == 'today' ||
        day.toLowerCase() == 'yesterday' ||
        day.toLowerCase() == 'tomorrow')
    ) {
      return true;
    } else {
      return false;
    }
  }
  parseDate(date: any) {
    return new Date(date);
  }

  dateToLocalTimeZone(value: any): Date {
    let nextDate = new Date(value);
    nextDate.setMinutes(
      nextDate.getMinutes() + -1 * new Date().getTimezoneOffset(),
    );
    return nextDate;
  }
}
